import type { PropsWithChildren } from 'react'
import React, { forwardRef } from 'react'
import styles from './scrollable.module.scss'

export type NativeScrollableProps = {
  height?: number | string
  className?: string
  showThumb?: boolean
}

export const Scrollable = forwardRef<HTMLDivElement, PropsWithChildren<NativeScrollableProps>>(
  ({ className, height = '100vh', showThumb = true, children }, ref) => {
    return (
      <div ref={ref} className={`${styles.scrollContainer} ${showThumb ? styles.hidden : ''} ${className ?? ''}`} style={{ maxHeight: height }}>
        {children}
      </div>
    )
  }
)
